module.exports = __webpack_public_path__ + "img/text.c1400503.svg";